import UpcomingEventsContainer from './UpcomingEventsContainer';

export default UpcomingEventsContainer;
